import { z } from "zod";
import type { MerchantEGiftCard } from "../types/eGiftCard.types";

interface EGiftCardFormValidationMessages {
  merchantRequired: string;
  giftCardRequired: string;
  startDateRequired: string;
  endDateRequired: string;
  dateRangeInvalid: string;
}

export const createEGiftCardFormSchema = (messages: EGiftCardFormValidationMessages) =>
  z.object({
    merchantBrandId: z.string().min(1, messages.merchantRequired),
    giftCardIds: z.array(z.string()).min(1, messages.giftCardRequired),
    giftCardItems: z.array(z.custom<MerchantEGiftCard>()),
    validFrom: z
      .date()
      .optional()
      .refine((date) => date !== undefined, messages.startDateRequired),
    validTo: z
      .date()
      .optional()
      .refine((date) => date !== undefined, messages.endDateRequired),
    timezone: z.string().min(1),
    isAlertLowStock: z.boolean(),
  }).refine(
    ({ validFrom, validTo }) => !validFrom || !validTo || validTo >= validFrom,
    {
      path: ["validTo"],
      message: messages.dateRangeInvalid,
    },
  );
